export default function ColHeaderFirst({ children }) {
  return (
    <div className='col-span-2 py-2.5 px-1 md:px-2.5 text-theme-intel-2020-e-gray-t2 font-medium text-srt-table-sm md:text-srt-table-base uppercase bg-theme-intel-2020-e-gray-s1 text-right grid grid-cols-1 content-center'>
      {children}
    </div>
  );
}
